/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Edit_DescriptionInputs */

const en_admin_posts_edit_description = /** @type {(inputs: Admin_Posts_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update post details`)
};

const zh_admin_posts_edit_description = /** @type {(inputs: Admin_Posts_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新文章信息`)
};

/**
* | output |
* | --- |
* | "Update post details" |
*
* @param {Admin_Posts_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_edit_description = /** @type {((inputs?: Admin_Posts_Edit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Edit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_edit_description(inputs)
	return zh_admin_posts_edit_description(inputs)
});
export { admin_posts_edit_description as "admin.posts.edit_description" }